export const Pin = ({ size }: { size?: string }) => {
  return (
    <svg
      className="tl"
      width={size ?? '37'}
      height={size ?? '37'}
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18.634" cy="18.6342" r="17.7805" fill="#BFC5D0" />
      <path
        d="M18.9319 10.293C17.1943 10.295 15.5285 10.9862 14.2998 12.2149C13.0712 13.4435 12.38 15.1094 12.3779 16.847C12.3759 18.2669 12.8397 19.6484 13.6983 20.7794C13.6983 20.7794 13.877 21.0147 13.9062 21.0487L18.9319 26.9759L23.9601 21.0457C23.9863 21.0141 24.1656 20.7794 24.1656 20.7794L24.1662 20.7776C25.0244 19.6471 25.488 18.2663 25.4859 16.847C25.4839 15.1094 24.7927 13.4435 23.5641 12.2149C22.3354 10.9862 20.6695 10.295 18.9319 10.293ZM18.9319 19.2302C18.4606 19.2302 17.9998 19.0905 17.6079 18.8286C17.2159 18.5667 16.9105 18.1945 16.7301 17.759C16.5497 17.3235 16.5025 16.8443 16.5945 16.382C16.6864 15.9197 16.9134 15.4951 17.2467 15.1617C17.58 14.8284 18.0047 14.6015 18.467 14.5095C18.9293 14.4175 19.4085 14.4647 19.844 14.6451C20.2795 14.8255 20.6517 15.131 20.9136 15.5229C21.1754 15.9148 21.3152 16.3756 21.3152 16.847C21.3144 17.4788 21.0631 18.0846 20.6163 18.5313C20.1695 18.9781 19.5638 19.2295 18.9319 19.2302Z"
        fill="white"
      />
    </svg>
  )
}
